import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollMainLayout } from '../app-layout/app-main-layout/AppMainLayout';

export interface ScrollPositionContextValue {
    scrollPositions: Record<string, number>;
    setScrollPosition: (path: string, position: number) => void;
}

const defaultValue: ScrollPositionContextValue = {
    scrollPositions: {},
    setScrollPosition: () => {},
};

const ScrollPositionContext = createContext(defaultValue);

export const ScrollPositionContextProvider = ({ children }: { children: ReactNode }) => {
    const [scrollPositions, setScrollPositions] = useState<Record<string, number>>({});
    const { pathname, hash } = useLocation();

    const setScrollPosition = (path: string, position: number) => {
        setScrollPositions((prev) => ({
            ...prev,
            [path]: position,
        }));
    };

    useEffect(() => {
        if (scrollPositions[pathname.concat(hash)]) {
            scrollMainLayout(0, scrollPositions[pathname.concat(hash)]);
            setScrollPosition(pathname.concat(hash), 0);
        }
    }, [pathname]);

    const value = useMemo(
        () => ({
            scrollPositions,
            setScrollPosition,
        }),
        [scrollPositions]
    );

    return <ScrollPositionContext.Provider value={value}>{children}</ScrollPositionContext.Provider>;
};

export const useScrollPositionContext = () => useContext(ScrollPositionContext);
